import UploadedDocument from './UploadedDocument.component';

export default UploadedDocument;